import React from 'react';
import { FormattedMessage as Trans } from 'react-intl';

import Button from './Button';

function JobListing({ listing }) {
  const { text, hostedUrl, categories } = listing;
  return (
    <>
      <div className="job-listing">
        <div className="job-listing__info">
          <div className="body --upper --small">{categories.team}</div>
          <Button
            button={{
              version: 'tertiary-text',
              href: hostedUrl,
              label: text
            }}
          />
        </div>
        <Button
          button={{
            version: 'primary',
            href: hostedUrl,
            label: <Trans id="buttonLabelApply" />
          }}
        />
      </div>
    </>
  );
}

export default JobListing;
